import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import dataroomConfig from '@/dataroom/app/config/config';

const { tenantDealvdr } = dataroomConfig.tenant;

export const savingsGuaranteeFootnoteUrl = dataroomUrl(tenantDealvdr.code).getSavingsGuaranteeFootnotePath();
